const Pulse02Icon = /*#__PURE__*/ [
  ["path", { d: "M2 12H5L6.5 8L9 15L10.5 12H12.5L14.5 7L16.5 17L19 12H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export { Pulse02Icon as default };
//# sourceMappingURL=Pulse02Icon.js.map
